import BaseService from 'services/base'

export default class HomeService extends BaseService {
  constructor(api) {
    const url = 'clientarea/home'
    super(api, url)
    this.api = api
    this.url = url
  }
}
